import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { MainScene } from "./MainScene";
import { GameIntroScene } from "./GameIntro";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.Paint;
        this.mainScene = MainScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "Paint.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "Paint.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "Paint.Phaser.HowToPlay.tabletInstructions";
    }
}



// WEBPACK FOOTER //
// ./src/games/PaintGame/scenes/IntroductionScene.ts